import { useCallback } from 'react';
import FormattedName from 'I18n/components/FormattedName';
// @ts-expect-error dependency missing types
import { OWNER } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error dependency missing types
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
// @ts-expect-error dependency missing types
import UnknownName from 'customer-data-reference-ui-components/name/UnknownName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <OwnerName id="123" email="foo@example.com" />
 * Renders as:
 *   My Owner Name
 */
const OwnerName = ({
  id,
  email,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  id: id,
  referenceObjectType: OWNER,
  onLoading: useCallback(() => email ? /*#__PURE__*/_jsx(FormattedName, {
    email: email
  }) : /*#__PURE__*/_jsx(SkeletonText, {}), [email]),
  onError: useCallback(() => email ? /*#__PURE__*/_jsx(FormattedName, {
    email: email
  }) : id || /*#__PURE__*/_jsx(UnknownName, {
    referenceObjectType: OWNER
  }), [id, email]),
  onResolved: useCallback(({
    reference
  }) => {
    const {
      firstName,
      lastName,
      email: resolvedEmail
    } = reference.referencedObject.toJS();
    return /*#__PURE__*/_jsx(FormattedName, {
      givenName: firstName,
      familyName: lastName,
      email: resolvedEmail
    });
  }, [])
  // NOTE: no default href because HubSpot has no direct url to view an owner
  //       See https://git.hubteam.com/HubSpot/CRM-Issues/issues/2735
  ,
  href: href,
  messageKey: messageKey
});
export default OwnerName;